module.exports = __webpack_public_path__ + "static/media/loc7_img14.3d3b3a57.jpg";